import React, { useState } from "react";
import {
  Input,
  Button,
  Select,
  message,
  Form,
  Popconfirm,
  Slider,
  Row,
  Col,
} from "antd";

import { ExclamationCircleOutlined } from "@ant-design/icons";
import HeatMapComponent from "../../../Components/HeatMapComponent";
import delIcon from "../../../Assets/Icons/deleteTable.svg";
import { useNavigate } from "react-router-dom";
import "./style.css";

const AddGeofences = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [radius, setRadius] = useState(100);

  const navigate = useNavigate();

  const handleSubmit = () => {
    const allValues = form.getFieldsValue(true);
    message.success("Added successfully!");
    navigate("/geofences");
  };
  const handleCancel = () => {
    form.resetFields();
    setSaved(false);
    message.info("Changes canceled");
  };

  const customerOptions = [
    { label: "John Doe", value: "john-doe" },
    { label: "Jane Smith", value: "jane-smith" },
    { label: "Michael Johnson", value: "michael-johnson" },
    { label: "Emily Davis", value: "emily-davis" },
  ];
  const vehicle = [
    { label: "Toyota Corolla", value: "toyota-corolla" },
    { label: "Honda Civic", value: "honda-civic" },
    { label: "Nissan Altima", value: "nissan-altima" },
    { label: "Ford F-150", value: "ford-f150" },
    { label: "Chevrolet Silverado", value: "chevrolet-silverado" },
    { label: "Hyundai Elantra", value: "hyundai-elantra" },
    { label: "Kia Sportage", value: "kia-sportage" },
    { label: "Mazda CX-5", value: "mazda-cx5" },
    { label: "Jeep Wrangler", value: "jeep-wrangler" },
    { label: "BMW 3 Series", value: "bmw-3series" },
    { label: "Mercedes-Benz C-Class", value: "mercedes-c-class" },
    { label: "Audi A4", value: "audi-a4" },
    { label: "Volkswagen Passat", value: "vw-passat" },
    { label: "Tesla Model 3", value: "tesla-model3" },
    { label: "Lexus RX 350", value: "lexus-rx350" },
  ];
  const geofenceTypeOptions = [
    { label: "Safe Zone", value: "Safe Zone" },
    { label: "Dangerous Zone", value: "Dangerous Zone" },
  ];

  const linkedAccountsOptions = [
    { label: "Account A", value: "accountA" },
    { label: "Account B", value: "accountB" },
    { label: "Account C", value: "accountC" },
  ];

  return (
    <div className="add-geofence">
      <div className="geo-form">
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <div className="geofence-container">
            <div className="heading">Create Geofence</div>

            <div className="selector-title">Customer Name</div>
            <div className="customer-selector">
              <Form.Item
                name="customer"
                rules={[
                  { required: true, message: "Please select a customer!" },
                ]}
              >
                <Select placeholder="Select" options={customerOptions} />
              </Form.Item>
            </div>
            <div className="geofence-details">
              <div className="input-group">
                <div className="title">Geofence Name</div>
                <Form.Item
                  name="geofenceName"
                  rules={[
                    { required: true, message: "Please enter geofence name!" },
                  ]}
                >
                  <Input placeholder="Enter geofence name" />
                </Form.Item>
              </div>
              <div className="input-group">
                <div className="title">Geofence Type</div>
                <Form.Item
                  name="Typegeo"
                  rules={[
                    {
                      required: true,
                      message: "Please select geofence type!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select type"
                    options={geofenceTypeOptions}
                  />
                </Form.Item>
              </div>

              <div className="input-group">
                <div className="title">Linked Vehicle</div>
                <Form.Item
                  name="linkedVehicles"
                  rules={[
                    {
                      required: true,
                      message: "Please select linked vehicles!",
                    },
                  ]}
                >
                  <Select
                    mode="multiple"
                    maxTagCount={1}
                    placeholder="Select linked vehicles"
                    options={vehicle.map((vehicle) => ({
                      label: vehicle?.label,
                      value: vehicle?.value,
                    }))}
                  />
                </Form.Item>
              </div>
              <div className="input-group">
                <div className="title">Linked Accounts</div>
                <Form.Item
                  name="linkedAccounts"
                  rules={[
                    {
                      required: true,
                      message: "Please select linked accounts!",
                    },
                  ]}
                >
                  <Select
                    mode="multiple"
                    maxTagCount={1}
                    placeholder="Select linked accounts"
                    options={linkedAccountsOptions}
                  />
                </Form.Item>
              </div>

              <div className="input-group">
                <div className="title">Type</div>
                <Form.Item
                  name="selectType"
                  rules={[{ required: true, message: "Please enter type!" }]}
                >
                  <Input placeholder="Enter type" />
                </Form.Item>
              </div>
              <div className="input-group">
                <div className="title">Descriptio/Notes(Optional)</div>
                <Form.Item name="descriptionNotes">
                  <Input placeholder="Enter customer name" />
                </Form.Item>
              </div>
            </div>
          </div>
          <div className="radius-container">
            <div className="radius-title">Radius </div>
            <Row gutter={24} align="middle">
              <Col span={20}>
                <Slider
                  min={10}
                  max={500}
                  value={radius}
                  onChange={setRadius}
                  trackStyle={{ backgroundColor: "#111111" }}
                />
              </Col>
              <Col span={4}>
                <Input
                  className="radius-input"
                  value={radius}
                  onChange={(e) => setRadius(Number(e.target.value))}
                />
              </Col>
            </Row>
          </div>

          <div className="geofence-container">
            <HeatMapComponent radius={radius} />
          </div>
          <div className="form-actions">
            <Button onClick={handleCancel}>Cancel</Button>
            <Button className="save-btn" type="primary" htmlType="submit">
              Save New Geofence
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AddGeofences;
